import NotificationsIcon from '@mui/icons-material/Notifications';
import { NotificationCreate } from './NotificationCreate';
import { NotificationEdit } from './NotificationEdit';
import { NotificationList } from './NotificationList';
import NotificationShow from './NotificationShow';

export default {
  list: NotificationList,
  create: NotificationCreate,
  edit: NotificationEdit,
  show: NotificationShow,
  icon: NotificationsIcon,
};
